module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="control-group">\n    <label for="relation-type">Relation type</label>\n    <select id="relation-type" class="relation-type-class" data-placeholder="Select a relation type">\n        <option value=""></option>\n        ';
 _.each(items, function(item){ 
__p+='\n        <option value="'+
((__t=( item.id ))==null?'':__t)+
'">'+
((__t=( item.name ))==null?'':__t)+
'</option>\n        ';
 }) 
__p+='\n    </select>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/relations/relations-types-select.html
// module id = 225
// module chunks = 0